import type { Form, FormField, FormShape } from "./types.ts";

export function shapeOf<F extends FormField>(form: Pick<Form<F>, "items">): FormShape<F> {
  return { items: form.items };
}

export function editableShape<F extends FormField>(form: Pick<Form<F>, "items" | "draft">): FormShape<F> {
  return form.draft ?? shapeOf(form);
}

export function hasUnpublishedChanges(form: Pick<Form, "status" | "draft">): boolean {
  return form.status !== "draft" && form.draft != null;
}

export function hasSomethingToPublish(form: Pick<Form, "status" | "draft">): boolean {
  return form.status !== "live" || form.draft != null;
}

export const UNTITLED_FORM = "Untitled form";

export type FormNameBlocker = { code: "NAME_REQUIRED" | "NAME_TAKEN"; message: string };

function nameKey(name: string): string {
  return name.trim().toLowerCase();
}

/** Published forms meet in every fill picker, so each needs a real name of its own. Drafts are free to repeat. */
export function formNameBlocker(name: string, otherPublishedNames: readonly string[]): FormNameBlocker | null {
  const key = nameKey(name);
  if (!key || key === nameKey(UNTITLED_FORM)) return { code: "NAME_REQUIRED", message: "A published form needs a name" };
  if (otherPublishedNames.some((other) => nameKey(other) === key)) {
    return { code: "NAME_TAKEN", message: `Another published form is named "${name.trim()}"` };
  }
  return null;
}
